import _objectSpread from "C:\\TMI-Projects\\TMI-MAT-Portal\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/esm/objectSpread";
import _slicedToArray from "C:\\TMI-Projects\\TMI-MAT-Portal\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/esm/slicedToArray";
import _objectWithoutProperties from "C:\\TMI-Projects\\TMI-MAT-Portal\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/esm/objectWithoutProperties";
import classNames from 'classnames';
import * as React from 'react';
import Anchor from '@restart/ui/Anchor';
import { useNavItem } from '@restart/ui/NavItem';
import { makeEventKey } from '@restart/ui/SelectableContext';
import { useBootstrapPrefix } from './ThemeProvider';
import { jsx as _jsx } from "react/jsx-runtime";
var defaultProps = {
  disabled: false
};
var NavLink = /*#__PURE__*/React.forwardRef(function (_ref, ref) {
  var bsPrefix = _ref.bsPrefix,
    className = _ref.className,
    _ref$as = _ref.as,
    Component = _ref$as === void 0 ? Anchor : _ref$as,
    active = _ref.active,
    eventKey = _ref.eventKey,
    props = _objectWithoutProperties(_ref, ["bsPrefix", "className", "as", "active", "eventKey"]);
  bsPrefix = useBootstrapPrefix(bsPrefix, 'nav-link');
  var _useNavItem = useNavItem(_objectSpread({
      key: makeEventKey(eventKey, props.href),
      active: active
    }, props)),
    _useNavItem2 = _slicedToArray(_useNavItem, 2),
    navItemProps = _useNavItem2[0],
    meta = _useNavItem2[1];
  return /*#__PURE__*/_jsx(Component, _objectSpread({}, props, navItemProps, {
    ref: ref,
    className: classNames(className, bsPrefix, props.disabled && 'disabled', meta.isActive && 'active')
  }));
});
NavLink.displayName = 'NavLink';
NavLink.defaultProps = defaultProps;
export default NavLink;